import I18n from "../../I18n";
import { datetime } from "../../utils";
import { prepareSeverityByStatus } from "../../utils/auditNoteSeverityConverter";

const mapCard = (json) => {
    const { AuditStatus, AuditNote, CreatedBy, CreationDate } = json;
    const replacedAuditStatus = AuditStatus.replaceAll(" ", "-");
    const { family, severity } = prepareSeverityByStatus((replacedAuditStatus || "").toLowerCase());

    return [
        [{ labels: ["AuditNote"], value: `${AuditNote}`, type: "string" }],
        [
            {
                value: {
                    severity: severity,
                    label: I18n.translate`${replacedAuditStatus}`,
                    family: family || "text",
                    color: "main",
                },
                type: "status",
            },
        ],
        [
            {
                labels: ["CreatedBy"],
                value: `${CreatedBy}`,
                type: "string",
                align: "center",
            },
        ],
        [
            {
                labels: ["CreatedIn"],
                value: `${datetime(CreationDate)}`,
                type: "string",
                align: "center",
            },
        ],
    ];
};

const header = [
    { label: ["Audit Note"], align: "left" },
    {
        label: ["Audit Status"],
        align: "center",
        type: "status",
    },
    { label: ["Created By"], align: "center" },
    { label: ["Created In"], align: "center" },
];

const mapper = (json, card) => {
    return {
        ...json,
        __typename: json.__typename,
        card: card ? mapCard(json) : [],
    };
};

const auditnoterecordMapper = {
    map: mapper,
    header,
};

export default auditnoterecordMapper;
